export default function PriceTable({ table, testId, dark = false }) {
    const head = dark ? "text-[#D4AF37]" : "text-[#C59B27]";
    const label = dark ? "text-[#F8D7E3]" : "text-[#3D2318]";
    const price = dark ? "text-[#FFFDF9]" : "text-[#C95B7D]";
    const line = dark ? "border-[#FFFDF9]/10" : "border-[#F2E1E6]";
    return (
        <div className="overflow-x-auto" data-testid={testId}>
            <table className="w-full text-left">
                <thead>
                    <tr>
                        <th className={`pb-3 text-[10px] font-bold uppercase tracking-[0.25em] ${head}`}>Size</th>
                        {table.columns.map((c) => (
                            <th key={c} className={`pb-3 text-right font-display text-lg sm:text-xl font-semibold ${label}`}>{c}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {table.rows.map((row) => (
                        <tr key={row.label} className={`border-t ${line}`} data-testid={`${testId}-row-${row.label.toLowerCase().replace(/\s+/g, "-")}`}>
                            <td className={`py-3.5 text-sm font-semibold ${label}`}>{row.label}</td>
                            {row.values.map((v, i) => (
                                <td key={i} className={`py-3.5 text-right font-display text-xl sm:text-2xl font-bold ${v === "—" ? "opacity-30 " + label : price}`}>{v}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
